<template>
    <div>
        <b-modal
            id="changePasswordModal"
            ref="changePasswordModal"
            :lazy="true"
            title-tag="h2"
            title="Change Password"
        >
            <form class="form-horizontal">
                <div class="form-group row">
                    <label for="current" class="col-sm-5 col-form-label"
                        >Current Password:</label
                    >
                    <div class="col-sm-7">
                        <input
                            id="current"
                            v-model="data.current"
                            v-validate="'required'"
                            :class="{ 'border-danger': errors.has('current') }"
                            type="password"
                            class="form-control"
                            name="current"
                            placeholder="Current password (required)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="new" class="col-sm-5 col-form-label"
                        >New Password:</label
                    >
                    <div class="col-sm-7">
                        <input
                            id="new"
                            v-model="data.new"
                            v-validate="'required'"
                            :class="{ 'border-danger': errors.has('new') }"
                            type="password"
                            class="form-control"
                            name="new"
                            placeholder="New password (required)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="new" class="col-sm-5 col-form-label"
                        >Password strength:</label
                    >
                    <div class="col-sm-7">
                        <div
                            id="passwordDescription"
                            class="span7"
                            style="float-left"
                        >
                            {{ passwordStrength.description }}
                        </div>
                        <div
                            id="passwordStrength"
                            :class="passwordStrength.class_name"
                        ></div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="repeat" class="col-sm-5 col-form-label"
                        >Repeat New Password:</label
                    >
                    <div class="col-sm-7">
                        <input
                            id="repeat"
                            v-model="data.repeat"
                            v-validate="'required'"
                            :class="{ 'border-danger': errors.has('repeat') }"
                            type="password"
                            class="form-control"
                            name="repeat"
                            placeholder="Repeat New password (required)"
                        />
                    </div>
                </div>
            </form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    @click="$refs.changePasswordModal.hide()"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button v-else variant="primary" @click="save"
                        >Save</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<style>
#passwordStrength {
    height: 10px;
    display: block;
    float: left;
}

.strength0 {
    width: 250px;
    background: #cccccc;
}

.strength1 {
    width: 50px;
    background: #ff0000;
}

.strength2 {
    width: 100px;
    background: #ff5f5f;
}

.strength3 {
    width: 150px;
    background: #56e500;
}

.strength4 {
    background: #4dcd00;
    width: 200px;
}

.strength5 {
    background: #399800;
    width: 250px;
}
</style>

<script>
export default {
    data() {
        return {
            data: {
                current: null,
                new: null,
                repeat: null
            },
            loading: false
        };
    },
    computed: {
        passwordStrength() {
            let password = this.data.new;
            let desc = new Array();
            desc[0] = "Very Weak";
            desc[1] = "Weak";
            desc[2] = "Better";
            desc[3] = "Medium";
            desc[4] = "Strong";
            desc[5] = "Strongest";
            let score = 0;

            if (password) {
                //if password bigger than 6 give 1 point
                if (password.length > 6) score++;

                //if password has both lower and uppercase characters give 1 point
                if (password.match(/[a-z]/) && password.match(/[A-Z]/)) score++;

                //if password has at least one number give 1 point
                if (password.match(/\d+/)) score++;

                //if password has at least one special caracther give 1 point
                if (password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/)) score++;

                //if password bigger than 12 give another 1 point
                if (password.length > 12) score++;

                // document.getElementById("passwordDescription").innerHTML =
                //     desc[score];
                // document.getElementById("passwordStrength").className =
                //     "strength" + score;
            }

            return {
                description: password ? desc[score] : "Password not entered",
                class_name: "strength" + score
            };
        }
    },
    methods: {
        open() {
            this.$refs.changePasswordModal.show();
        },
        save() {
            let self = this;

            if (this.data.new !== this.data.repeat) {
                this._message(
                    "New and Repeat New passwords do not match",
                    "warning"
                );
                return;
            }

            self.$refs.changePasswordModal.$validator
                .validateAll()
                .then(result => {
                    if (result) {
                        self.loading = true;

                        let post = {
                            current: self.data.current,
                            new: self.data.new,
                            repeat: self.data.repeat
                        };

                        return this.$http
                            .post(
                                process.env.ACTOR_SERVICE +
                                    "staff/change-password",
                                post
                            )
                            .then(function (response) {
                                if (
                                    response.data.response.message.code === 200
                                ) {
                                    if (response.data.response.resource.message)
                                        self._message(
                                            response.data.response.resource
                                                .message,
                                            "success"
                                        );

                                    self.$refs.changePasswordModal.hide();
                                } else {
                                    self._message(
                                        "Current password is incorrect",
                                        "warning"
                                    );
                                }
                            })
                            .finally(() => (self.loading = false));
                    }
                });
        }
    }
};
</script>
